import React from 'react';

import PolicyFooterSection from '../../components/PolicyFooterSection';
import FooterSection from './FooterSection';

const Footer = () => {
  return (
    <footer css={{position: 'relative', overflow: 'hidden'}}>
      <FooterSection />
      <PolicyFooterSection />
    </footer>
  );
};

export default Footer;
